import ReactDOM from 'react-dom/client';
import './styles/index.css';
import App from './App';
import { installTableResize } from './components/common/tableResize';

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);

root.render(<App />);

// drag the right edge of any table header to resize the column (all `table.bd-table`)
installTableResize();
